import React from "react";
import { Switch, Route } from "react-router-dom";
import App from "../components/App";
import LoginPage from "../components/login/loginPage";
import CallbackPage from "../components/login/callbackPage";

export default (
  <Switch>
    <Route exact path="/callback">
      <CallbackPage />
    </Route>
    <Route exact path="/login">
      <LoginPage />
    </Route>
    <Route path="*">
      <App />
    </Route>
  </Switch>
);
